import { useEffect, useState } from "react";
import TableComponent from "../../../components/TableComponent";
import "../hrreports.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTable } from "@fortawesome/free-solid-svg-icons";
import HRreports from "../HRreports";
import API from "../../../api/axiosConfig";
import TestPreLoader from "../../TestPreLoader/TestPreLoader";

function InvestigationReport() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState([]);

 

 
  const handleDownload = (selectedRows) => {
    let activeRows, activeColumns;
    activeRows = rows;
    activeColumns = columns1;
    const selectedData = activeRows.filter((row) =>
      selectedRows.includes(row.id)
    );
    if (selectedData.length === 0) {
      alert("Please select at least one row.");
      return;
    }

    const csvHeader = activeColumns
      .filter((col) => col.key !== "actions")
      .map((col) => col.name)
      .join(",");

    const csvRows = selectedData.map((row) =>
      activeColumns
        .filter((col) => col.key !== "actions")
        .map((col) => `"${row[col.key] || ""}"`)
        .join(",")
    );

    const csvContent = `${csvHeader}\n${csvRows.join("\n")}`;

    const bom = "\uFEFF";
    const finalContent = bom + csvContent;

    const blob = new Blob([finalContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "selected_rows_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const columns1 = [
    { name: "إسم المحقق", key: "investigator" },
    { name: "إسم المحقق معه", key: "name" },
    { name: "الوصف", key: "description" },
    { name: "التاريخ", key: "date" },
    { name: "النتيجة", key: "result" },
    { name: "", key: "actions" },
  ];

  const dropdownOptions1 = [{ label: "تعديل", route: "/editInvestigations/:id" }];
  // const getInvestigationReport = async () => {
  //   try {
  //     const res = await API.get("/investigations");
  //     const data = await res;
  //     if (data.status === 200) {
  //       setRows(data.data);
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     setError(error.response.data.errors);
  //     setMessage(error.response.data.message);
  //   }
  // };
  

  // useEffect(() => {
  //   getInvestigationReport();
  // }, []);
  return (
    // loading && <TestPreLoader /> ||
    <>
      <HRreports activeTab="investigationreport" />
      <div className="hrReports-tabel">
        {/* <CustomTable
          title="تقارير التحقيقات الادارية"
          titleIcon={<FontAwesomeIcon icon={faTable} />}
          onDownload={handleDownload}
          columns={columns1}
          data={rows.map((row) => ({
            id: row.id,
            investigator: row.investigator,
            name: row.employee.name,
            desc: row.description,
            date: row.date,
            result: row.result,
          }))}
          dropdownOptions={dropdownOptions1}
        />{" "} */}
        <TableComponent
          apiUrl="/investigations"
          columns={columns1}
          titleIcon={<FontAwesomeIcon icon={faTable} />}
          title="تقارير التحقيقات الادارية"
          onDownload={handleDownload}
          dropdownOptions={dropdownOptions1}
        />
      </div>
    </>
  );
}

export default InvestigationReport;
